import $ from 'jquery'; 
window.$ = window.jQuery = $;
let dt = require('datatables.net');
//import 'datatables.net-dt/css/jquery.datatables.css';

$(document).ready(function()
{
	$('#item-datatable').DataTable(
	{
	    "order": [ [ 0, 'desc' ]],
	    "displayLength": 25,
	    responsive: true,
	    processing: true,
	    serverSide: true,
	    ajax: "/get/item/list",
	    columns:[
	                { data: 'item_id' },
	                { data: 'itemName' },
	                { data: 'categoryType' },
	                { data: 'price' },
	                { data: 'options' },
	            ]      
	});
	$('#admin-item-datatable').DataTable(
	{
	    "order": [ [ 0, 'desc' ]],
	    "displayLength": 25,
	    responsive: true,
	    processing: true,
	    serverSide: true,
	    ajax: "/get/admin/item/list",
	    columns:[
	                { data: 'item_id' },
	                { data: 'companyName' },
	                { data: 'itemName' },
	                { data: 'categoryType' },
	                { data: 'price' },
	                { data: 'options' },
	            ]      
	});
	$(document).ready(function() 
	{
		const statusValues = {
		        receivedValue: 'Received',
		        preparingValue: 'Preparing',
		        delayedValue: 'Delayed',
		        readyValue: 'Ready',
		        deliveredValue: 'Delivered',
		        cancelledValue: 'Cancelled'
		    };
	    initializeDataTable('#order-datatable', '/get/vendor/order/list', statusValues);
	    initializeDataTable('#daily-order-datatable', '/get/vendor/daily/order/list', statusValues);
	});
	$('#user-order-datatable').DataTable(
	{
	    "order": [ [ 0, 'desc' ]],
	    "displayLength": 25,
	    processing: true,
	    responsive: true,
	    serverSide: true,
	    ajax: "/get/order/history",
	    columns:[
	                { data: 'order_id' },
	                { data: 'companyName' },
	                { data: 'price' },
	                { data: 'status' },
	                { data: 'created_at' },
	                { data: 'options' },
	            ]      
	});
	$('#category-datatable').DataTable(
	{
	    "order": [ [ 0, 'desc' ]],
	    "displayLength": 25,
	    responsive: true,
	    processing: true,
	    serverSide: true,
	    ajax: "/get/vendor/category/list",
	    columns:[
	                { data: 'category_id' },
	                { data: 'categoryType' },
	                { data: 'options' },
	            ]      
	});
	$('#admin-category-datatable').DataTable(
	{
	    "order": [ [ 0, 'desc' ]],
	    "displayLength": 25,
	    responsive: true,
	    processing: true,
	    serverSide: true,
	    ajax: "/get/admin/category/list",
	    columns:[
	                { data: 'category_id' },
	                { data: 'categoryType' },
	                { data: 'options' },
	            ]      
	});
	$('#admin-vendor-datatable').DataTable(
	{
	    "order": [ [ 0, 'desc' ]],
	    "displayLength": 25,
	    responsive: true,
	    processing: true,
	    serverSide: true,
	    ajax: "/get/admin/vendor/list",
	    columns:[
	                { data: 'vendor_id' },
	                { data: 'companyName' },
	                { data: 'name' },
	                { data: 'email' },
	            ]      
	});
});                                                                            

function initializeDataTable(selector, ajaxUrl, statusValues) 
{
    $(selector).DataTable(
    {
        "order": [[0, 'desc']],
        "displayLength": 25,
        responsive: true,
        processing: true,
        serverSide: true,
        ajax: 
        {
        	url: ajaxUrl,
        	dataSrc: function(json) 
        	{
        		$(selector).data('statusValues', statusValues);
        	    return json.aaData;
        	}
        },
        columns: [
            { data: 'order_id' },
            { data: 'name' },
            { data: 'phoneNumber' },
            { data: 'price' },
            { data: 'status' },
            { data: 'created_at' },
            { data: 'timer' },
            { data: 'view' },
            { data: 'options' }
        ],
        "rowCallback": function(row, data, dataIndex) 
        {
        	let statusValues = $(selector).data('statusValues');
            let timer = data.timer;
            let status = data.status;
            if (!timer) return;
            let parts = timer.split(':');
            let totalMinutes;
            if (parts.length === 2) 
            {
                totalMinutes = parseInt(parts[0]) * 60 + parseInt(parts[1]);
            } else if (parts.length === 3) 
            {
                totalMinutes = parseInt(parts[0]) * 60 + parseInt(parts[1]) + (parseInt(parts[2]) / 60);
            }
            if (totalMinutes > 20) 
            {
                switch(status) 
                {
                     case statusValues.receivedValue:
                        $('td', row).addClass('bg-secondary');
                        break;
                    case statusValues.preparingValue:
                        $('td', row).addClass('bg-warning');
                        break;
                    case statusValues.delayedValue:
                        $('td', row).addClass('bg-danger');
                        break;
                    case statusValues.readyValue:
                        $('td', row).addClass('bg-success');
                        break;
                    case statusValues.deliveredValue:
                        $('td', row).addClass('bg-primary');
                        break;
                    case statusValues.cancelledValue:
                        $('td', row).addClass('bg-dark');
                        break;
                    default:
                        break;
                }
            }
        }
    });
}
